module.exports = __webpack_public_path__ + "img/1508311998.71812802.jpg";